import { LOCALE_ID, Inject, Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CalendarEventTitleFormatter, CalendarEvent } from 'angular-calendar';
import { formatDate } from '@angular/common';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import _moment from 'proxies/dayjs';
@Injectable()
export class CustomEventTitleFormatter extends CalendarEventTitleFormatter implements OnDestroy {
    moment = _moment;
    // event: CalendarEvent<any>;
    data: any;
    private calendarSub: Subscription;
    
    constructor(
        @Inject(LOCALE_ID) private locale: string,
        private communication: CommunicationService
    ) {
        super();
        this.calendarSub = this.communication.emitCalendar.subscribe((data: any) => {
            this.data = data;
        })
    }

    // component-scoped provider: Angular calls this when the calendar is destroyed
    ngOnDestroy() {
        this.calendarSub?.unsubscribe();
    }

    month(event: CalendarEvent): string {
        return `<b>${formatDate(event.start, 'hh:mm a', this.locale)} - ${formatDate(event.end, 'hh:mm a', this.locale)}</b> ${event.title
            }`;
    }

    monthTooltip(event: CalendarEvent, title: string): string {
        return `${formatDate(event.start, 'hh:mm aa', this.locale)} - ${formatDate(event.end, 'hh:mm a', this.locale)}` + " , "+ this.maketitle(this.data.toolTip,event);
    }

    week(event: CalendarEvent): string {
        return `<span class="rounded mt-1 bg-white border px-1 text-dark">${formatDate(event.start, 'hh:mm a', this.locale)} - ${formatDate(event.end, 'hh:mm a', this.locale)}</span><br> <span class="text-dark">${event.title
            }</span>`;
    }

    weekTooltip(event: any, title: string): any {
        return `${formatDate(event.start, 'hh:mm a', this.locale)} - ${formatDate(event.end, 'hh:mm a', this.locale)}` + " , "+this.maketitle(this.data.toolTip,event);
    }

    day(event: CalendarEvent): string {
        return `<span class="rounded mt-1 bg-white border px-1 text-dark">${formatDate(event.start, 'hh:mm aa', this.locale)} - ${formatDate(event.end, 'hh:mm a', this.locale)}</span><br> ${event.title
            }`;
    }

    dayTooltip(event: CalendarEvent, title: string): any {
        return `${formatDate(event.start, 'hh:mm aa', this.locale)} - ${formatDate(event.end, 'hh:mm a', this.locale)}` + " , "+this.maketitle(this.data.toolTip,event);
    }

    maketitle(title: any, item) {
        var str = ""
        if (Object.keys(title).length != 0) {
            str = Object.keys(title).filter(x=>eval(title[x])(item)!="").map(x => { return x + " : " + eval(title[x])(item) }).join(" , ")
            return str
        } else {
            return str
        }
    }

    getData(callback: any) {
        // this.communication.emitCalendar.subscribe((data: any) => {
            // console.log("data is ",data);
            // this.baseService.get(this.data.toolTip.datasource.query_id, this.makeArgs(this.data.toolTip.datasource.args, this.event), this.data.toolTip.datasource.resource, this.data.toolTip.datasource.application).subscribe((res: any) => {
            //     if (res.resource.length != 0) {
            //         callback(res.resource[0])
            //     } else {
            //         callback(false)
            //     }

            // })
        // })
    }

    // makeArgs(argument, value) {
    //     let str = argument;
    //     let data = {
    //         start_date: this.moment(value.start_date).valueOf(),
    //         end_date: this.moment(value.end_date).valueOf(),
    //         id: value.doctor_id,
    //         facility_id: value.facility_id
    //     }
    //     let result = str.match(/\!!!(.*?)\!!!/gm);
    //     for(let i = 0; i < result.length; i++) {
    //         str = str.replace(result[i], data[result[i].replace(/!!!/g, "")])
    //     }
    //     return str;
    // }
}